import React from 'react';
import PropTypes from 'prop-types';

import { st, classes } from './AnnouncementModalLayout.st.css';
import TextButton from '../TextButton';
import { dataHooks } from './constants';

import BaseModalLayout from '../BaseModalLayout';
import Button from '../Button';
import { WixStyleReactContext } from '../WixStyleReactProvider/context';
import { AnnouncementModalLayoutProps } from './AnnouncementModalLayout.types';

/** A layout for announcement modals, to be used inside a &lt;Modal /&gt; */
const AnnouncementModalLayout = ({
  theme = 'standard',
  actionsSize = 'medium',
  ...propsWithoutDefaults
}: AnnouncementModalLayoutProps) => {
  const { className, children, ...restProps } = {
    theme,
    actionsSize,
    ...propsWithoutDefaults,
  };
  return (
    <WixStyleReactContext.Consumer>
      {({ newColorsBranding }) => (
        // @ts-ignore
        <BaseModalLayout
          className={st(classes.announcementModalLayout, className)}
          {...restProps}
        >
          <BaseModalLayout.Illustration />
          <BaseModalLayout.Header
            titleSize={newColorsBranding ? 'extraLarge' : 'large'}
          />
          {/* @ts-ignore */}
          <BaseModalLayout.Content hideTopScrollDivider hideBottomScrollDivider>
            {children}
          </BaseModalLayout.Content>
          <BaseModalLayout.Footer />
          <Link {...restProps} />
          <div className={classes.bottomSpacing} />
          <BaseModalLayout.Footnote />
        </BaseModalLayout>
      )}
    </WixStyleReactContext.Consumer>
  );
};

const Link = ({
  linkText,
  linkOnClick,
  theme,
}: Partial<AnnouncementModalLayoutProps>) =>
  ((linkText || linkOnClick) && (
    <div className={classes.link}>
      <TextButton
        size="small"
        weight="normal"
        dataHook={dataHooks.link}
        onClick={linkOnClick}
        skin={theme}
      >
        {linkText}
      </TextButton>
    </div>
  )) ||
  null;

AnnouncementModalLayout.displayName = 'AnnouncementModalLayout';

AnnouncementModalLayout.propTypes = {
  className: PropTypes.string,
  dataHook: PropTypes.string,
  onCloseButtonClick: PropTypes.func,
  onHelpButtonClick: PropTypes.func,
  theme: PropTypes.oneOf(['standard', 'premium']),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  actionsSize: Button.propTypes.size,
  primaryButtonText: PropTypes.string,
  primaryButtonOnClick: PropTypes.func,
  primaryButtonProps: (() => {
    const { dataHook, ...buttonProps } = Button.propTypes;
    return PropTypes.shape(buttonProps);
  })(),
  secondaryButtonText: PropTypes.string,
  secondaryButtonOnClick: PropTypes.func,
  secondaryButtonProps: (() => {
    const { dataHook, ...buttonProps } = Button.propTypes;
    return PropTypes.shape(buttonProps);
  })(),
  sideActions: PropTypes.node,
  footnote: PropTypes.node,
  illustration: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  linkText: PropTypes.string,
  linkOnClick: PropTypes.func,
};
export default AnnouncementModalLayout;
